import { type Activity, type LearnerState, type Program, initialState } from "./contract";

export const normalize = (s: string) =>
  s.normalize("NFC").trim().toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, " ");
export function checkAnswer(activity: Activity, answer: string) {
  return activity.mode === "open"
    ? "pending"
    : activity.answers.some((a) => normalize(a) === normalize(answer))
      ? "correct"
      : "incorrect";
}
export function migrateState(previous: Program, next: Program, state: LearnerState): LearnerState {
  const result = initialState();
  result.sequence = state.sequence;
  result.view = { ...state.view };
  result.pools = { ...state.pools };
  const pages = next.pages;
  if (pages) {
    const oldPages = previous.pages ?? [];
    const oldIndex = oldPages.findIndex((p) => p.id === state.viewedPageId);
    result.viewedPageId =
      pages.find((p) => p.id === state.viewedPageId)?.id ??
      [...oldPages]
        .sort(
          (a, b) =>
            Math.abs(oldPages.indexOf(a) - oldIndex) - Math.abs(oldPages.indexOf(b) - oldIndex)
        )
        .find((p) => pages.some((n) => n.id === p.id))?.id ??
      pages[0].id;
  }
  for (const a of next.activities) {
    const old = previous.activities.find((v) => v.id === a.id);
    if (!old) continue;
    if (
      JSON.stringify([old.mode, old.answers, old.options, old.prompt]) !==
      JSON.stringify([a.mode, a.answers, a.options, a.prompt])
    )
      throw new Error("Changed answer semantics require a new activity ID");
    for (const key of ["answers", "attempts", "results", "hints", "orders"] as const) {
      Object.assign(result[key], a.id in state[key] ? { [a.id]: state[key][a.id] } : {});
    }
  }
  return result;
}
